module.exports = __webpack_public_path__ + "img/doller.7f5e6e29.svg";